import { useMemo } from 'react'
import CruiseLuxPlusLabel from 'components/Cruises/CruiseLuxPlusLabel'
import Group from 'components/utils/Group'
import { getIsEnabledLuxPlusCruiseInclusions } from 'luxPlus/selectors/featureToggle'
import CruiseLuxPlusOnboardCreditLabel from 'components/Cruises/CruiseInclusion/CruiseLuxPlusOnboardCreditLabel'
import { useAppSelector } from 'hooks/reduxHooks'
import { buildAllStandardInclusions } from 'lib/cruises/cruiseInclusionsUtils'
import CruiseLimitedInclusionList from './CruiseLimitedInclusionList'

const VISIBLE_INCLUSIONS = 3

interface Props {
  evergreenInclusions?: Array<App.PackageInclusion>
  tileInclusions?: Array<App.OfferInclusion>
  standardInclusions: Array<App.PackageInclusion>
  luxPlusInclusions: Array<App.PackageInclusion>
  canSeeLuxPlusLabel?: boolean
  offer?: App.CruiseOffer
  showMoreOnSeparateLine?: boolean
}

function CruiseInclusionListHomeTile({
  standardInclusions,
  evergreenInclusions,
  tileInclusions,
  luxPlusInclusions,
  canSeeLuxPlusLabel,
  offer,
  showMoreOnSeparateLine,
}: Props) {
  const isEnabledLuxPlusCruiseInclusions = useAppSelector(getIsEnabledLuxPlusCruiseInclusions)

  const allInclusions = useMemo(() => {
    return [
      ...buildAllStandardInclusions(standardInclusions, tileInclusions, true),
      ...(evergreenInclusions || []),
    ]
  }, [standardInclusions, tileInclusions, evergreenInclusions])

  const hasLuxPlusInclusions = isEnabledLuxPlusCruiseInclusions && luxPlusInclusions.length > 0
  const hasNormalInclusions = allInclusions.length > 0
  const hasInclusions = hasNormalInclusions || hasLuxPlusInclusions || canSeeLuxPlusLabel

  return <>
    {hasInclusions && <Group direction="vertical" gap={16} horizontalAlign="start">
      {(canSeeLuxPlusLabel || hasLuxPlusInclusions) && (
        <Group direction="vertical" gap={8} verticalAlign="center">
          {canSeeLuxPlusLabel && <CruiseLuxPlusLabel
            isModalEnabled
            offer={offer}
          />}

          {hasLuxPlusInclusions && (
            <CruiseLuxPlusOnboardCreditLabel
              luxPlusInclusions={luxPlusInclusions}
              offer={offer}
            />
          )}
        </Group>
      )}

      {hasNormalInclusions && (
        <CruiseLimitedInclusionList
          inclusions={allInclusions}
          showMoreOnSeparateLine={showMoreOnSeparateLine}
          visibleItems={VISIBLE_INCLUSIONS}
        />
      )}
    </Group>}
  </>
}

export default CruiseInclusionListHomeTile
